import { useAuthContext } from './AuthContext';
import type { AuthState, AuthUser } from './types';

export function useAuth(): AuthState {
  return useAuthContext();
}

export function useAuthUser(): AuthUser {
  const state = useAuthContext();
  if (state.status !== 'authenticated') {
    throw new Error('useAuthUser called outside authenticated context');
  }
  return state.user;
}
